import BaseViewController from "./base-view-controller";

const PCP_PROVIDER_ID = "pcp.provider_id";
const SEND_CCR_TO_PCP_FLG = "send_ccr_to_pcp_flg";
const PHONEFAXTYPE_WORK = "pcp.phone_faxes.0.phone_fax_type_cd";
const PHONEFAXTYPE_WORKFAX = "pcp.phone_faxes.1.phone_fax_type_cd";

class ConsultationImagesPcp extends BaseViewController {
  prepareSubmit(values) {
    const pcpProviderId = values[PCP_PROVIDER_ID];
    const isPcpProviderNotSelected =
      !pcpProviderId ||
      (pcpProviderId instanceof Object && !pcpProviderId.value);
    return {
      ...values,
      [PHONEFAXTYPE_WORK]: isPcpProviderNotSelected ? "PHONEFAXTYPE_WORK" : "",
      [PHONEFAXTYPE_WORKFAX]: isPcpProviderNotSelected
        ? "PHONEFAXTYPE_WORKFAX"
        : "",
      [SEND_CCR_TO_PCP_FLG]: isPcpProviderNotSelected ? "N" : "Y",
      // Data for dermatology treatments
      ...this.appData.dermTreatmentData
    };
  }
}

export default ConsultationImagesPcp;
